'use client';

import { getFragmentData } from '@/__generated__';
import { ENTRY_BASE_FRAGMENT } from '@/gql/fragments/entries.gql';
import { NavMenuItem } from '@/lib/parsers/navigation';
import useScrollPosition from '@/lib/utils/useScrollPosition';
import { useBreakpointMin } from '@/theme';
import { BoxProps } from '../ui/Box';
import { BtnProps } from '../ui/Btn';
import Flex, { FlexProps } from '../ui/Flex';
import { TxtProps } from '../ui/Txt';
import NavItem from './NavItem';
import { useNavBar } from './useNavBar';

export type NavMenu = FlexProps<
  'ul',
  {
    items?: NavMenuItem[];
    ItemProps?: BoxProps<'li'>;
    TxtProps?: TxtProps;
    BtnProps?: BtnProps;
  }
>;

export default function NavMenu({ items, ItemProps, TxtProps, BtnProps, ...props }: NavMenu) {
  const { primaryItems, page } = useNavBar();
  const pos = useScrollPosition();
  const md = useBreakpointMin('md');

  const base = getFragmentData(ENTRY_BASE_FRAGMENT, page);
  const eventUri = base?.sectionHandle === 'event';

  const btnProps: BtnProps = {
    ...(pos < 10 && eventUri && { color: 'white' }),
    ...BtnProps,
  };

  const txtProps: TxtProps = {
    cx: { fontSize: 'h5' },
    ...TxtProps,
  };

  if (!md) return null;

  return (
    <Flex as="ul" direction="row" alignItems="center" spacing="md" {...props}>
      {(items || primaryItems)?.map((item) => {
        return (
          <NavItem
            key={item.id}
            {...{ item, TxtProps: txtProps, BtnProps: btnProps, ...ItemProps }}
          />
        );
      })}
    </Flex>
  );
}
